import Animate, { AnimationTypes } from "../../../components/Animate/Animate"

export const SmallInfo = ({ label, value }: { label: string; value: string }) => (
  <Animate type={AnimationTypes.slideUpIn} duration="1.5s">
    <div className="rounded-lg border-2 border-slate-200 bg-slate-50 px-3 py-2">
      <p className="text-[11px] uppercase text-slate-500">{label}</p>

      <p className="mt-1 font-semibold text-slate-900">{value}</p>
    </div>
  </Animate>
)
